import { jsx as _jsx } from "react/jsx-runtime";
import { classNames, responsiveClassNames } from "../../utilities/props.js";
import getTextAlignStyles from "../../styles/textAlign/index.js";
import s from "./Text.module.css";
const tagMap = {
    "title-1": "h1",
    "title-2": "h2",
    "title-3": "h3",
    "title-4": "h4",
    "title-5": "h5",
    "title-6": "h6",
};
const Text = (props) => {
    const { variant, color, weight, align, decoration, maxLines, wrap, children, className, attributes, } = props;
    const largestVariant = typeof variant === "string" ? variant : variant?.xl || variant?.l || variant?.m || variant?.s;
    const alignStyles = getTextAlignStyles(align);
    // Using any here to let TS save on type resolving, otherwise TS throws an error due to the type complexity
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const TagName = props.as || (largestVariant && tagMap[largestVariant]) || "div";
    const rootClassName = classNames(s.root, color && s[`--color-${color}`], ...responsiveClassNames(s, "--variant", variant), ...responsiveClassNames(s, "--weight", weight), decoration && s[`--decoration-${decoration}`], maxLines !== undefined && s[`--clamp`], maxLines === 1 && s["--break-all"], wrap && s[`--wrap-${wrap}`], className);
    const style = {
        ...attributes?.style,
        ...alignStyles?.variables,
        "--rs-text-lines": maxLines,
    };
    return (_jsx(TagName, { ...attributes, className: rootClassName, style: style, children: children }));
};
Text.displayName = "Text";
export default Text;
